import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { DotsHorizontalIcon, ExternalLink, HeaderButton, Popover, ScrollArea, } from "@sundae/ui-toolkit";
import { useAppContext } from "../../stores/index.js";
const QuickMenuPopover = ({ className, openFrom = "top", }) => {
    const { currentLocale } = useI18N();
    const { state: { clientSettings: { quickMenuPopover }, }, } = useAppContext();
    if (!quickMenuPopover) {
        return null;
    }
    return (_jsx(Popover, { className: className, primitiveProps: {
            arrow: { offset: 15 },
            content: { side: openFrom, style: { marginRight: 10 } },
        }, trigger: _jsx(HeaderButton, { children: _jsx(DotsHorizontalIcon, {}) }), withCloseIcon: false, children: _jsx(ScrollArea, { primitiveProps: { viewport: { className: "max-h-screen" } }, children: _jsx("div", { className: "grid gap-4 p-4 xl:gap-2", children: quickMenuPopover?.(currentLocale).map(({ title, link, icon }) => (_jsxs(ExternalLink, { className: "flex items-center justify-between", href: link, size: "sm", children: [title, icon] }, title))) }) }) }));
};
export default QuickMenuPopover;
//# sourceMappingURL=QuickMenuPopover.js.map